import { Plus, ChevronLeft, Lock as LockIcon } from 'lucide-react';
import PlanGate from '../../../../components/gating/PlanGate';
import { partnerData } from '../../utils/partnerHelpers';

const PartnerHeader = ({ viewMode, onToggleMode }) => {
  const { title, description } = partnerData.header;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 sm:mb-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">
          {title}
        </h1>
        <p className="text-xs sm:text-sm text-slate-500 mt-0.5 sm:mt-1">
          {description}
        </p>
      </div>
      <PlanGate
        requiredPlan="growth"
        featureName="Partner Management"
        tooltipText="Partner Management requires the Growth Plan."
        showLockIcon={false}
        wrapperClassName="w-full sm:w-auto"
      >
        {({ isLocked }) => (
          <button
            onClick={onToggleMode}
            className="flex items-center justify-center gap-2 bg-[#067978] hover:bg-[#056362] text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-2xl font-bold text-xs sm:text-sm shadow-md shadow-[#067978]/20 transition-all hover:shadow-lg active:scale-95 whitespace-nowrap w-full sm:w-auto cursor-pointer"
          >
            {viewMode !== 'list' ? (
              <>
                <ChevronLeft size={16} /> Back to List
              </>
            ) : (
              <>
                <Plus size={18} className="stroke-[2.5]" />
                <span>Add Partner</span>
                {isLocked && <LockIcon size={14} className="ml-1 text-white/90 shrink-0" />}
              </>
            )}
          </button>
        )}
      </PlanGate>
    </div>
  );
};

export default PartnerHeader;
